import { generateClient, GraphQLResult } from "aws-amplify/api";
// @ts-ignore
import { getFieldInstance } from "../graphql/queries";
import { recordSentry } from "utils/recordSentry";
import { FieldInstance } from "db/definitions";

async function _getFieldInstance(id: string): Promise<FieldInstance | void> {
	interface QueryResponse {
		getFieldInstance: FieldInstance;
	}
	try {
		const client = generateClient({ authMode: "userPool" });
		const result = (await client.graphql({
			query: getFieldInstance,
			variables: {
				id,
			},
			authMode: "userPool",
		})) as unknown as GraphQLResult<QueryResponse>;

		return result.data.getFieldInstance;
	} catch (error) {
		recordSentry({ error });
	}
}

export default _getFieldInstance;
